
export default {

	/**
	* @method Utils
	* @see src/common/scripts/utils/utils.js
	*
	* @description
	* Utils methods
	*
	*	import utils from "Utils/utils";
	*
	*	utils.checkIf("isNumber", "2", 0);
	*	utils.isArray(value);
	*	utils.isDOMNode(value);
	*	utils.isDOMNodeList(value);
	*	utils.isFunction(value);
	*	utils.isNotEmptyObject(value);
	*	utils.isNotEmptyString(value);
	*	utils.isNumber(value);
	*	utils.isObject(value);
	*/
	checkIf (util, value, defaultValue) {

		util = this.isFunction(this[util]) ? this[util] : false;

		return util && util.call(this, value) ? value : defaultValue;

	},
	isArray (value) {
		return value instanceof Array;
	},
	isDOMNode (node) {
		return typeof node === 'object' && node instanceof Node;
	},
	isDOMNodeList (nodeList) {
		return typeof nodeList === 'object' && nodeList instanceof NodeList;
	},
	isFunction (check) {
		return typeof check === 'function';
	},
	isNotEmptyObject (value) {
		return !!(this.isObject(value) && Object.keys(value).length);
	},
	isNotEmptyString (value) {
		value = 'string' === typeof value ? value.trim() : false;
		return value !== false && '' !== value;
	},
	isNumber (value) {
		return typeof value === 'number' && !isNaN(value);
	},
	isObject (value) {
		var conditions = [
			typeof value === 'object' && value !== null,
			!(value instanceof Array),
			!(value instanceof Date && !isNaN(value.getTime())),
			!(value instanceof RegExp),
			value instanceof Boolean !== true,
			value instanceof Number !== true,
			value instanceof String !== true
		];
		return conditions.indexOf(false) < 0;
	}

};
